import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../../Contexts/userContext";
import { classesURL, dashboardURL } from "../../Hooks/URL";
import Dashboard from "../../Templates/Dashborad/Dashboard";
import useFetchWhen from "../../Hooks/useFetchWhen";

function DashboardPage() {
  const { contextData, setContextData } = useContext(userContext);

  const [statistics, setStatistics] = useState("");
  const { data, loading, error } = useFetchWhen(
    dashboardURL,
    contextData?.role == "admin" || contextData?.role == "school"
  );

  const [classes, setClasses] = useState([]);
  const {
    data: classesData,
    loading: classesLoading,
    error: classesError,
  } = useFetchWhen(
    `${classesURL}?sort=startDate&limit=3&page=1`,
    contextData?.role == "admin" || contextData?.role == "school"
  );

  useEffect(() => {
    if (!classesLoading && !classesError && classesData) {
      setClasses(classesData?.data?.data?.rows);
    }
  }, [classesData, classesLoading, classesError]);

  useEffect(() => {
    if (!loading && !error && data) {
      setStatistics(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "dashboard" });
  }, []);

  return (
    <Dashboard
      contextData={contextData}
      statistics={statistics}
      loading={loading}
      classes={classes}
      classesLoading={classesLoading}
    />
  );
}

export default DashboardPage;
